export default {
    setEntityData(context, payload) {
        context.commit("setEntityData", payload);
    },
    setFillableSettings(context, payload) {
        context.commit("setFillableSettings", payload);
    },
};
